module.exports = __webpack_public_path__ + "c01e454e926ee60770e693f68c5a84b5.svg";


//////////////////
// WEBPACK FOOTER
// ../images/icons/svg/rounded-arrow-down.svg
// module id = 2186
// module chunks = 69